module.exports = __webpack_public_path__ + "static/media/modifySearch.fb0e7bb0.svg";